import { useSiteSettings } from "../../../contexts/SiteSettingsContext";
import ImageUploadField from "./ImageUploadField";

export default function GeneralTab() {
  const { settings, updateSettings } = useSiteSettings();

  return (
    <div className="space-y-8">
      {/* ヘッダー設定 */}
      <div>
        <h3 className="text-sm font-bold text-gray-700 mb-4 pb-2 border-b border-gray-200">ヘッダー設定</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">サイトタイトル</label>
            <input
              type="text"
              value={settings.headerTitle}
              onChange={(e) => updateSettings({ headerTitle: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="サイトタイトル"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">サブタイトル（ヘッダー上部の小文字）</label>
            <input
              type="text"
              value={settings.headerSubtitle}
              onChange={(e) => updateSettings({ headerSubtitle: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="サブタイトル"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">サイトURL（タイトルクリック先）</label>
            <input
              type="url"
              value={settings.headerUrl}
              onChange={(e) => updateSettings({ headerUrl: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="https://example.com/"
            />
          </div>
        </div>
      </div>

      {/* ヒーローエリア設定 */}
      <div>
        <h3 className="text-sm font-bold text-gray-700 mb-4 pb-2 border-b border-gray-200">ヒーローエリア設定</h3>
        <div className="space-y-4">
          <ImageUploadField
            label="ヒーロー画像（URLまたはアップロード）"
            value={settings.heroImageUrl}
            onChange={(url) => updateSettings({ heroImageUrl: url })}
            placeholder="https://example.com/image.jpg"
            previewClassName="h-32 w-full object-cover rounded-md"
          />
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">ヒーローテキスト（改行可）</label>
            <textarea
              value={settings.heroText}
              onChange={(e) => updateSettings({ heroText: e.target.value })}
              rows={4}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400 resize-y"
              placeholder="ヒーローエリアに表示するテキスト"
            />
          </div>
        </div>
      </div>

      {/* FC2アフィリエイト設定 */}
      <div>
        <h3 className="text-sm font-bold text-gray-700 mb-4 pb-2 border-b border-gray-200">FC2アフィリエイト設定</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">FC2アフィリエイトID</label>
            <input
              type="text"
              value={(settings as Record<string, unknown>).fc2AffiliateId as string || ""}
              onChange={(e) => updateSettings({ fc2AffiliateId: e.target.value } as Record<string, unknown>)}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="例: 12345678"
            />
            <p className="text-xs text-gray-400 mt-1">
              FC2アフィリエイト管理画面で確認できるIDを入力してください。商品リンクに自動付与されます。
            </p>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">最低価格フィルタ（pt）</label>
            <input
              type="number"
              value={(settings as Record<string, unknown>).fc2MinPrice as number || 3000}
              onChange={(e) => updateSettings({ fc2MinPrice: parseInt(e.target.value, 10) || 3000 } as Record<string, unknown>)}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="3000"
              min={0}
              step={100}
            />
            <p className="text-xs text-gray-400 mt-1">
              この価格以上の商品のみ表示します（デフォルト: 3,000pt）
            </p>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">表示件数（新作・おすすめ各）</label>
            <input
              type="number"
              value={(settings as Record<string, unknown>).fc2Limit as number || 12}
              onChange={(e) => updateSettings({ fc2Limit: parseInt(e.target.value, 10) || 12 } as Record<string, unknown>)}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="12"
              min={4}
              max={24}
              step={4}
            />
          </div>
        </div>
      </div>

      {/* SNSリンク設定 */}
      <div>
        <h3 className="text-sm font-bold text-gray-700 mb-4 pb-2 border-b border-gray-200">SNSリンク設定</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">リンクテキスト</label>
            <input
              type="text"
              value={settings.socialLinkText}
              onChange={(e) => updateSettings({ socialLinkText: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">リンクURL</label>
            <input
              type="url"
              value={settings.socialLinkHref}
              onChange={(e) => updateSettings({ socialLinkHref: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">サブテキスト</label>
            <input
              type="text"
              value={settings.socialLinkSub}
              onChange={(e) => updateSettings({ socialLinkSub: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
